import styled from "styled-components";

export const ClientsWEWorkStyled = styled.div`
  .client_works_heading {
    margin-bottom: 50px;
    @media (max-width: 1199px) {
      margin-bottom: 30px;
    }
    @media (max-width: 899px) {
      margin-bottom: 20px;
    }
  }
  .marquee_slide_wrap {
    background: rgba(239, 239, 239, 0.5);
    box-shadow: 0px 4px 9.7px rgba(0, 0, 0, 0.25);
    border-radius: 25px;
    padding: 31.5px 24px;
    @media (max-width: 1199px) {
      padding: 20px;
      border-radius: 15px;
    }
    @media (max-width: 899px) {
      padding: 20px 15px;
      border-radius: 10px;
    }
    .figureWrap {
      padding: 0 42px;
      line-height: 0;
      @media (max-width: 1199px) {
        padding: 0 20px;
      }
      @media (max-width: 599px) {
        padding: 0 15px;
      }
      figure {
        width: auto;
        height: 80px;
        line-height: 0;
        aspect-ratio: 2/1;
        @media (max-width: 599px) {
          height: 60px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
`;
